
/**
 * 选择框模式
 */
export enum ECheckMode {
  /**
   * 单选框
   */
  Radio = 'radio',
  /**
   * 多选框
   */
  Checkbox = 'checkbox'
}



// WEBPACK FOOTER //
// ./src/enums/ECheckMode.ts